import PropTypes from 'prop-types';

import { Skeleton } from '@material-ui/lab';
import { withStyles } from '@material-ui/core/styles';

import { RatingDetails } from 'evee-ui-common/components/base';
import { customer } from 'evee-ui-common/types';

const styles = () => ({
  title: {
    fontSize: '20px',
    fontWeight: 500,
  },
});

const ProfileRating = ({ account, loading, classes, ...rest }) => {
  const { averageRating, reviewsCount } = account;

  return loading ? (
    <Skeleton height="1.5em" />
  ) : (
    <RatingDetails
      value={averageRating}
      reviewsCount={reviewsCount}
      classes={{ rating: classes.title, reviews: classes.title }}
      {...rest}
    />
  );
};

ProfileRating.propTypes = {
  account: customer.customerPropType,
  loading: PropTypes.bool,
  classes: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
};

ProfileRating.defaultProps = {
  account: {},
  loading: false,
};

export default withStyles(styles)(ProfileRating);
